import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiFetch } from "../APIClient";

const declineReservationChange = async (reservationId: number): Promise<void> => {
  const response = await apiFetch(`api/reservation/${reservationId}/change-request/decline`, {
    method: "POST",
  });

  if (!response.ok) {
    let errorMessage = "일정 변경을 거절하지 못했습니다. 잠시 후 다시 시도해주세요.";
    try {
      const errorData = await response.json();
      errorMessage = errorData.message || errorMessage;
    } catch (e) {
      // Ignore if error response is not JSON or empty
    }
    throw new Error(errorMessage);
  }
};

export const useDeclineReservationChange = () => {
  const queryClient = useQueryClient();

  return useMutation<void, Error, number>({
    mutationFn: declineReservationChange,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["myUpcomingReservations"] });
      queryClient.invalidateQueries({ queryKey: ["myPastReservations"] });
    },
    onError: (error) => {
      console.error("Decline reservation change failed:", error);
    },
  });
};
